<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="$store.state.drawer"
      app
      clipped

    >


    <v-list dense>



    </v-list>

<v-list-item-group>
    <v-list shaped  >
	    <v-list-item >
	   		<v-list-item-icon>
            <v-icon >mdi-message-video</v-icon>
          </v-list-item-icon>
          <v-list-item-content @click="shuttleList()">
            <v-list-item-title > My Shuttles </v-list-item-title>
          </v-list-item-content>


	    </v-list-item>


        <v-list-item >
        <v-list-item-icon>
            <v-icon >mdi-crosshairs-question</v-icon>
          </v-list-item-icon>
          <v-list-item-content @click="quizList()">
            <v-list-item-title > My Quizzes</v-list-item-title>
          </v-list-item-content>


      </v-list-item>



      <v-list-item :to="'/settings/list/' + this.$store.state.dynamo.customer_id">
	   		<v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Shuttle Options</v-list-item-title>
          </v-list-item-content>
	    </v-list-item>


    </v-list>
</v-list-item-group>

</v-navigation-drawer>


    <v-app-bar
      app
      clipped-left
      dark


    >
      <v-app-bar-nav-icon @click.stop="drawer=updateDrawer()" />
       <img class="ma-1" src="/images/logos/shuttle-icon.png" width="24"  />
      <v-toolbar-title>
        <span class="title">Shuttle Studio</span>
      </v-toolbar-title>


      <v-spacer></v-spacer>







      <v-btn
        color="#0882B8"
        small
        @click="createNewQuiz()"
        v-if="this.$route.name == 'Quiz List'"
        class="mx-2"
      >
        + Create Quiz
      </v-btn>






<v-btn
  color="primary"
  @click="createNewShuttle()"
  v-if="this.$route.name == 'Shuttle List'"
  small
  height="33"
>
  + Create Shuttle
</v-btn>


<!-- alerts -->

<v-menu
       v-model="alerts_menu"
       :close-on-content-click="false"
       :nudge-width="200"
       offset-x
     >
       <template v-slot:activator="{ on, attrs }">
         <v-btn
           text
           v-bind="attrs"
           v-on="on"
         >
           <v-badge
             :content="userAlerts.length"
             :value="userAlerts.length"
             color="#0882b8"
             overlap
           >
             <v-icon>mdi-bell</v-icon>
           </v-badge>
         </v-btn>
       </template>

       <v-card>

         <v-divider></v-divider>

         <v-list>
           <v-list-item v-for="(alert_item,aidx) in userAlerts" :key="aidx">
             <v-list-item-action>

             </v-list-item-action>
             <v-list-item-title>{{ alert_item.msg }}</v-list-item-title>
             <v-list-item-subtitle>{{ alert_item.timestamp }}</v-list-item-subtitle>
           </v-list-item>

           <v-list-item>
             <v-list-item-action>

             </v-list-item-action>
             <v-list-item-title></v-list-item-title>
           </v-list-item>
         </v-list>


       </v-card>
     </v-menu>


<!-- alerts end -->




      <!-- settings -->
      <v-menu
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">

                <v-btn
                  text
                  v-on="on"
                  class="mx-2"
                  outlined
                  v-bind="attrs"
                >
                  <v-icon left>mdi-account</v-icon>
                  {{ menuUsername }}
                  <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>

              </template>

              <v-card class="px-4">

                  <v-list>
                    <v-list-item class="ml-0 mr-4">
                      <v-list-item-title><v-icon>mdi-theme-light-dark</v-icon>Dark Mode</v-list-item-title>
                      <v-list-item-action>
                        <v-switch @change="setTheme($event)"></v-switch>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item class="ml-0 mr-4">
                      <v-list-item-title><v-icon>mdi-translate</v-icon>Language</v-list-item-title>
                      <v-list-item-action>

                      </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                    <br/>
                    <v-list-item>
                      <br/><v-btn width="100%" @click="handleLogout()"><v-icon>mdi-logout</v-icon>Logout</v-btn>
                    </v-list-item>

                    <v-list-item caption>
                     customer id: <br> {{this.$store.state.auth.sub}}
                    </v-list-item>
                  </v-list>



              </v-card>
            </v-menu>

        <!-- settings end -->

















    </v-app-bar>


      <v-container fluid class="grey lighten-4" style="height:100%;">
        <v-row>


          <router-view></router-view>

        </v-row>

      </v-container>




    <v-snackbar
      v-model="message_show"
      :color="$store.state.global_message.color"
      :timeout="message_timeout"
      outlined
      top

    >
      {{$store.state.global_message.message}}



    </v-snackbar>


    <v-overlay :value="$store.state.loader_overlay">
      <v-progress-circular indeterminate size="100" width="2"></v-progress-circular>
      <br />
      <span class="title">{{ $store.state.overlay_loading_message }}<span class="one">.</span><span class="two">.</span><span class="three">.</span></span>
    </v-overlay>


  <v-footer app dark>
    <span>&copy; 2021</span>
  </v-footer>
</v-app>
</template>
<script>


import { mapState } from 'vuex';
import store from '../store';
import { v4 as uuidv4 } from 'uuid';

import QuizMixins from '@/mixins/QuizMixins.js';
import ShuttleMixins from '@/mixins/ShuttleMixins.js';
import validations from '@/mixins/validations.js';


export default {
  name: 'Studio',
  mixins:[QuizMixins,ShuttleMixins,validations],
  data() {
    return {
      tokenExpire: null,
      message_show:false,
      message_timeout:1000,
      alerts_menu: false,

    	selected:0,
    	drawer:true,
    	navigation_items:[
    		{text:"My Courses", icon:"mdi-message-video", route:"list"},
    		{text:"Analytics", icon:"mdi-chart-line-variant", route:"analytics"},
    		{text:"Settings", icon:"mdi-cog-box", route:"settings"}

    	],







    }
  },

  async beforeRouteEnter(to, from, next) {
    /* This function will run before the Studio route is navigated to.
        Check if user authenticated (tokens exist) before loading the route.
        next() will be called on successful route and move to Studio route.
        next({name:"Login"}) will be called to move user back to login if tokens don't exists.

        "this" will not exist within this scope since component has not yet been loaded.
    */

    ////console.log("STORE");
    ////console.log(store);
    if (store.state.hashtokens) {
      if (store.state.hashtokens['id_token']) {
        // id_token exists, continue to Studio
        next();
      } else {
        // hashtokens is not null but no id_token exists for some reason... Go to login.
        next({name: "Home"});
      }
    } else {
      // no tokens exist. hashtokens object is null. Direct to login.
      next({name: "Home"});
    }
  },

  methods: {

    async getToken() {
      var authresponse  = await this.authorizeCognitoUser();

      if (authresponse.AuthenticationResult) {
        if (authresponse.AuthenticationResult.IdToken) {
          //console.log("NEW TOKENS!!!");
          var new_creds = {
            hashtokens: {
                access_token: authresponse.AuthenticationResult.AccessToken,
                expires_in: 3600,
                id_token: authresponse.AuthenticationResult.IdToken,
                refresh_token: this.$store.state.hashtokens.refresh_token,
                token_type: 'Bearer'
            },
            auth: this.$store.state.auth
          };
          this.$store.commit('setUserAuthCredentials', new_creds);
          ////console.log("*** UPDATED NEW CREDENTIALS ***");
        }
      }

      clearInterval(this.tokenExpire);
      //console.log("CLEARED TOKEN");
      this.tokenExpire = setInterval(this.getToken, 600000);
      //console.log('REFRESHED TOKEN');
    },


    setTheme(theme_change) {
      this.$vuetify.theme.dark = theme_change;
    },

    newalert() {
      this.$store.dispatch('addNewProcess', {startAlertMsg:'Process began',endAlertMsg:'Process ended'});

    },
    handleLogout() {
      var vm = this;
      this.$store.dispatch('signOut').then((result) => {
        ////console.log("LOGGING OUT / SIGNING OUT");
        ////console.log(result);
        vm.$router.push({name:'Login'});
      }).catch((err) => {
        ////console.log("LOGGING OUT / SIGNING OUT : CATCH ERROR");
        ////console.log(err);
        vm.$router.push({name:'Login'});
      });
    },

  	shuttleList(item){
  		//////console.log('process item')
  		this.$router.push({path:'/studio/list/' + this.$store.state.dynamo.customer_id})

  	},

    createNewShuttle() {

        /* At the moment this will create a new shuttle even if the user does
            not select/upload/drag a video to upload.


            should this change? should the user NEED to upload/select/drag a
              video before the shuttle is actually created?

        */


        let shuttle_id = uuidv4();
        this.$router.push({path:'/studio/edit/' + shuttle_id});
    },


  },


 created(){

      this.tokenExpire = setInterval(this.getToken(), 10000);
      var vm = this;
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
            ////console.log(mutation.type);

            if(mutation.type == 'global_message'){
              this.message_show = false;

                this.message_show = true;
            }


          });



 },
  beforeDestroy() {
    clearInterval(this.expireToken);

    this.unsubscribe();
  },



    computed: {
      menuUsername() {
          if (this.$store.state['auth']) {
            if (this.$store.state['auth'].username) {
              return this.$store.state['auth'].username;
            }
          }

          return '';
      },


      userAlerts() {
        return this.$store.state.alertNotices;
      },





    },


}
</script>


<style scoped>
.one {
    opacity: 0;
    -webkit-animation: dot 1.3s infinite;
    -webkit-animation-delay: 0.0s;
    animation: dot 1.3s infinite;
    animation-delay: 0.0s;
}

.two {
    opacity: 0;
    -webkit-animation: dot 1.3s infinite;
    -webkit-animation-delay: 0.2s;
      animation: dot 1.3s infinite;
      animation-delay: 0.2s;
}

.three {
    opacity: 0;
    -webkit-animation: dot 1.3s infinite;
    -webkit-animation-delay: 0.3s;
     animation: dot 1.3s infinite;
     animation-delay: 0.3s;
}

@-webkit-keyframes dot {
      0% { opacity: 0; }
     50% { opacity: 0; }
    100% { opacity: 1; }
}

@keyframes dot {
      0% { opacity: 0; }
     50% { opacity: 0; }
    100% { opacity: 1; }
}

</style>
